import React from 'react';

const Hindi = () => {
  return (
    <div>
      Hindi
      Hindi
    </div>
  );
}

export default Hindi;
